export default "__VITE_ASSET__DUr96jcA__"